/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { Ownable__factory } from "./Ownable__factory";
